<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name:'App',
    data(){
        return{

        }
    },
    methods:{

    },
    components:{

    },
    mounted(){

    }
}
</script>

<style rel="stylesheet" lang="scss">
    @import 'scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue